export enum WidgetRenderModeE {
  floating = "floating",
  embedded = "embedded",
  iframe = "iframe",
}
